module.exports = __webpack_public_path__ + "e0411249f6019e58eb2df0af8608b6d7.MP3";